// extracted by mini-css-extract-plugin
export const blogPost = "blog-post-module--blogPost--3Yspu";
export const blogPostNav = "blog-post-module--blogPostNav--3hDsJ";
export const heroImage = "blog-post-module--heroImage--3Jw9G";